import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import CreateSearchTagMutation from '@/graphql/contracts/createSearchTag.mutation.gql';
import { CreateSearchTag, CreateSearchTagVariables } from '@/graphql/contracts/_generated_/createSearchTag.mutation';
import { SearchTagTypeEnum } from '@/graphql/contracts/_generated_/contracts';
import { notificationService } from '@/services/notification/notification.client';

type SearchTagInputType = {
  tag: string;
  tagType: SearchTagTypeEnum;
  targetID: string;
};

export default function useCreateSearchTag() {
  const [_createSearchTag, { loading }] = useMutation<CreateSearchTag, CreateSearchTagVariables>(
    CreateSearchTagMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const createSearchTag = (input: SearchTagInputType) => {
    _createSearchTag({
      variables: {
        input
      }
    });
  };

  return {
    createSearchTag,
    isLoadingGetSearchTags: loading
  } as const;
}
